module.exports = __webpack_public_path__ + "static/media/Lace-parasol-409794.8932eeb6.jpg";